import {Link, useNavigate} from "react-router-dom";
import React, {useState} from "react";

// MUI
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Chip from "@mui/material/Chip";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

// MUI Icons
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';

// App imports
import Login from "../login/Login";

const RepositoryManagementHome = (props) => {
    return (<>
        <main>
            <div>
                {props.authString
                    ? <MainContent authString={props.authString}/>
                    : <Login setAuthString={props.setAuthString} />
                }
            </div>
        </main>
    </>);
};

const MainContent = (props) => {
    const navigate = useNavigate();

    const [state, setState] = useState({repositories: [], DataisLoaded: false});

    const fetchRepositories = () => {
        var requestUrl = process.env.REACT_APP_API_BASE_URL + 'admin/repositories';

        fetch(requestUrl, {
            method: 'GET',
            headers: new Headers({
                'Content-Type': 'application/json',
                'Authorization': `Basic ${props.authString}`
            })
        })
        .then(response => response.json())
        .then((responseJson) => {
            setState({
                DataisLoaded: true,
                repositories: responseJson['repositories']
            });
        });
    };

    React.useEffect( () => {
        if (!props.authString) {
            console.log("not logged in");
            navigate("/login");
        } else {
            fetchRepositories();
        }
    }, [navigate, props.authString]);

    const handleDelete = (repoId) => {
        const requestUrl = process.env.REACT_APP_API_BASE_URL + `admin/repositories/${repoId}/delete`;

        fetch(requestUrl, {
            method: 'DELETE',
            headers: new Headers({
                'Content-Type': 'application/json',
                'Authorization': `Basic ${props.authString}`
            })
        })
        .then(response => response.json())
        .then((data) => {
            if (data.success) {
                console.log('Repository deleted successfully:', data.message);
                // Refresh the repository list
                fetchRepositories();
            } else {
                console.error('Delete failed:', data.error);
                alert(`Failed to delete repository: ${data.error}`);
            }
        })
        .catch((error) => {
            console.error('Error deleting repository:', error);
            alert('An error occurred while deleting the repository.');
        });
    };

    if (state.DataisLoaded) {
        return (<>
            <Box className='repository-management'>
                <div className='repository-management-title'>
                    <span style={{marginLeft: '40px'}}>Data Repository Management</span>

                    <Link to={'add'}>
                        <Button size="small" variant="contained" style={{ margin: '-2px 20px', padding: '4px 12px', float: 'right', color: 'black', backgroundColor: 'rgb(242, 246, 247)' }}>
                            <AddIcon /> Add
                        </Button>
                    </Link>
                </div>

                <TableContainer component={Paper}>
                    <Table sx={{minWidth: 650}} aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell>Repository ID</TableCell>
                                <TableCell>Repository Name</TableCell>
                                <TableCell>Short Name</TableCell>
                                {/*<TableCell>Published</TableCell>*/}
                                {/*<TableCell>Last Edited</TableCell>*/}
                                <TableCell>Status</TableCell>
                                <TableCell align="center">Edit</TableCell>
                                <TableCell align="center">Preview</TableCell>
                                <TableCell align="center">Delete</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <RepositoryManagementList
                                repositories={state.repositories}
                                onDelete={handleDelete}
                            />
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        </>);
    }
};

const RepositoryManagementList = (props) => {
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const [repositoryToDelete, setRepositoryToDelete] = useState(null);

    const handleDeleteClick = (repository) => {
        setRepositoryToDelete(repository);
        setDeleteDialogOpen(true);
    };

    const handleDeleteConfirm = () => {
        if (repositoryToDelete) {
            props.onDelete(repositoryToDelete.id);
        }
        setDeleteDialogOpen(false);
        setRepositoryToDelete(null);
    };

    const handleDeleteCancel = () => {
        setDeleteDialogOpen(false);
        setRepositoryToDelete(null);
    };

    return (
        <>
            {props.repositories.map((row) => (
                <TableRow
                    key={row.id}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                    <TableCell align="center">
                        {row.id}
                    </TableCell>
                    <TableCell component="th" scope="row">
                        {row.name}
                    </TableCell>
                    <TableCell>
                        {row.nickname}
                    </TableCell>
                    {/*<TableCell>*/}
                    {/*    {row.published}*/}
                    {/*</TableCell>*/}
                    {/*<TableCell>*/}
                    {/*    {row.last_edited}*/}
                    {/*</TableCell>*/}
                    <TableCell>
                        {publish_status(row.status) === 0 &&
                            <Chip className='status-chip'
                                style={{backgroundColor: 'rgba(94, 191, 96, 1)', color: 'white'}}
                                label='Published'/>
                        }
                        {publish_status(row.status) === 1 &&
                            <Chip className='status-chip'
                                style={{ backgroundColor: 'rgba(186, 144,59, 1)', color: 'white' }}
                                label='In Review' />
                        }
                        {publish_status(row.status) === 2 &&
                            <Chip className='status-chip'
                                style={{ backgroundColor: 'rgba(186, 144,59, 1)', color: 'white' }}
                                label='Ready for Publish' />
                        }
                        {publish_status(row.status) === 3 &&
                            <Chip className='status-chip'
                                style={{ backgroundColor: '#737373', color: 'white' }}
                                label='Draft' />
                        }
                    </TableCell>
                    <TableCell align="center">
                        <Link to={'edit/' + row.id}>
                            <Button size="small" variant="text" className="text-button" sx={{padding: 0}}>
                                <EditIcon />
                            </Button>
                        </Link>
                    </TableCell>
                    <TableCell align="center">
                        <Link to={'preview/' + row.id}>
                            <Button size="small" variant="text" className="text-button" sx={{padding: 0}}>
                                <VisibilityIcon />
                            </Button>
                        </Link>
                    </TableCell>
                    <TableCell align="center">
                        <Button
                            size="small"
                            variant="text"
                            className="text-button"
                            sx={{padding: 0, color: '#d32f2f'}}
                            onClick={() => handleDeleteClick(row)}
                        >
                            <DeleteIcon />
                        </Button>
                    </TableCell>
                </TableRow>
            ))}

            {/* Delete Confirmation Dialog */}
            <Dialog
                open={deleteDialogOpen}
                onClose={handleDeleteCancel}
                aria-labelledby="delete-dialog-title"
                aria-describedby="delete-dialog-description"
            >
                <DialogTitle id="delete-dialog-title">
                    Confirm Repository Deletion
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="delete-dialog-description">
                        Are you sure you want to delete the repository <strong>"{repositoryToDelete?.name}"</strong>?
                        <br /><br />
                        This action will permanently delete:
                        <ul>
                            <li>The repository record</li>
                            <li>All associated affiliations, organisms, data types, formats, and research areas</li>
                            <li>Repository contacts and additional fields</li>
                            <li>The repository logo (if exists)</li>
                        </ul>
                        <strong>This action cannot be undone.</strong>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDeleteCancel} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleDeleteConfirm} color="error" variant="contained" autoFocus>
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

const publish_status = (value) => {
    switch (value) {
        case 'Published':
            return 0;
        case 'In Review':
            return 1;
        case 'Ready for Publish':
            return 2;
        default:
            return 3;
    }
}

export default RepositoryManagementHome;